





























import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class LessonIcon extends Vue {
  @Prop({ default: false }) private tick!: boolean;
  @Prop({ default: "https://via.placeholder.com/80x80.png" })
  private icon!: string;
  @Prop({ default: false }) private small!: boolean;
}
